import { format } from 'date-fns';
import { PropertyType as PT } from '../../../common';

export const mapEntityToApi = (data: PT): PT => ({
	uid: data.uid,
	logged_user_id: data.uid,
	sid: data.token,
});

const mapPartners = (partners: PT[]) => {
	let result: PT[] = [];
	if (partners?.length) {
		result = partners.reduce((curr: PT[], item) => {
			const newPartner: PT = {
				label: item.name,
				value: item.gid,
				skinId: item.skinid,
				partnerId: item.partnerid,
			};
			if (item.sub_groups) newPartner.options = mapPartners(item.sub_groups);
			return [...curr, newPartner].sort((a, b) => a.label?.trim()?.localeCompare(b.label.trim()));
		}, []);
	}
	return result;
};

const mapActivePartners = (partners: PT[]) =>
	partners.reduce((curr: PT[], item) => {
		let active = [...curr];
		if (item.checked === 2) active.push(item);
		if (item.sub_groups) active = active.concat(mapActivePartners(item.sub_groups));

		return active;
	}, []);

const getActivePartners = (topLevel: PT) => {
	if (topLevel.checked === 2) return [{ label: topLevel.name, value: topLevel.gid }];
	return mapPartners(mapActivePartners(topLevel.sub_groups));
};

const mapPermissions = (props: PT) => {
	const perms = { ...props };
	for (const p in perms) perms[p] = perms[p] === 'true';
	return perms;
};

const mapRoles = (roles: PT[]) => roles.map((r) => ({ label: r.name, value: r.name }));

const formatToOption = (value: string) => [
	{
		label: value,
		value: value,
	},
];

const formatLastActivity = (lastActivity: string) => {
	if (!lastActivity) return '';
	const actDate = lastActivity;
	return format(new Date(actDate), 'eeee, MMM dd yyyy');
};

export const mapApiToEntity = (data: PT): PT => {
	const {
		user_id,
		username,
		email,
		state,
		last_activity,
		profile_image,
		date_format,
		lang_id,
		currency,
		group_tree,
		props,
		roles,
		default_values,
	} = data.userData;

	return {
		id: user_id,
		username: username,
		email: email,
		isActive: !!parseInt(state),
		lastActivity: formatLastActivity(last_activity),
		image: profile_image,
		activeDateTime: formatToOption(date_format),
		activeLanguage: formatToOption(lang_id),
		activeCurrency: formatToOption(currency),
		partnersRawData: group_tree.sub_groups,
		partners: mapPartners(group_tree.sub_groups),
		activePartners: getActivePartners(group_tree),
		permissions: mapPermissions(props),
		roles: mapRoles(roles),
		defaults: {
			language: formatToOption(default_values.lang_id),
			dateTime: formatToOption(default_values.date_format),
		},
	};
};
